import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';
import Theme from '../../../styles/Theme/Theme';
import CustomIcon from '../../Global/Icons/CustomIcon';
//import * as IconsLibrary from '../../Global/Icons/Library';
import * as IconsLibrary from '../../../assets/icons/_index';

const iconsList = Object.keys(IconsLibrary);

export const Icons = (props) => {
  return (

    <div style={{}}>
      {iconsList.map((icon) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>

            <div>
              <CustomIcon label={icon.key} icon={icon} iconSize='md' BgColor='' fill='black' />
              <CustomIcon icon={icon} iconSize='md' BgColor='#0076A8' fill='white' />
            </div>


            <span style={{ fontSize: '14px', paddingLeft: '15px' }}>{icon}</span>
          </div>

        )
      })}
    </div>

  )
}